import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlertifyComponent } from '@app/modules/apps/pages/alertify/alertify.component';
import { AutohostComponent } from '@app/modules/apps/pages/autohost/autohost.component';
import { BetterStrComponent } from '@app/modules/apps/pages/better-str/better-str.component';
import { BreezewayComponent } from '@app/modules/apps/pages/breezeway/breezeway.component';
import { ChekinComponent } from '@app/modules/apps/pages/chekin/chekin.component';
import { CraftedstaysComponent } from '@app/modules/apps/pages/craftedstays/craftedstays.component';
import { CrewdogsComponent } from '@app/modules/apps/pages/crewdogs/crewdogs.component';
import { HostbuddyAiComponent } from '@app/modules/apps/pages/hostbuddy-ai/hostbuddy-ai.component';
import { HostkitComponent } from '@app/modules/apps/pages/hostkit/hostkit.component';
import { HoufyComponent } from '@app/modules/apps/pages/houfy/houfy.component';
import { HudsonCreativeStudioComponent } from '@app/modules/apps/pages/hudson-creative/hudson-creative.component';
import { JervisComponent } from '@app/modules/apps/pages/jervis/jervis.component';
import { LinkbaseComponent } from '@app/modules/apps/pages/linkbase/linkbase.component';
import { MinutComponent } from '@app/modules/apps/pages/minut/minut.component';
import { PricelabsComponent } from '@app/modules/apps/pages/pricelabs/pricelabs.component';
import { QuickbooksComponent } from '@app/modules/apps/pages/quickbooks/quickbooks.component';
import { RankbreezeComponent } from '@app/modules/apps/pages/rankbreeze/rankbreeze.component';
import { ResortcleaningComponent } from '@app/modules/apps/pages/resortcleaning/resortcleaning.component';
import { RueBaRueComponent } from '@app/modules/apps/pages/rue-ba-rue/rue-ba-rue.component';
import { SafelyComponent } from '@app/modules/apps/pages/safely/safely.component';
import { StrlyComponent } from '@app/modules/apps/pages/strly/strly.component';
import { SuiteopComponent } from '@app/modules/apps/pages/suiteop/suiteop.component';
import { TechtapeComponent } from '@app/modules/apps/pages/techtape/techtape.component';
import { TheHostCoComponent } from '@app/modules/apps/pages/the-host-co/the-host-co.component';
import { TouchstayComponent } from '@app/modules/apps/pages/touchstay/touchstay.component';
import { VRPlatformComponent } from '@app/modules/apps/pages/vr-platform/vr-platform.component';
import { WebreadyComponent } from '@app/modules/apps/pages/webready/webready.component';
import { WelcomescreenComponent } from '@app/modules/apps/pages/welcomescreen/welcomescreen.component';
import { ApiKeysComponent } from './pages/api-keys/api-keys.component';
import { AppsOverviewComponent } from './pages/apps-overview/apps-overview.component';
import { BeyondComponent } from './pages/beyond/beyond.component';
import { BoostlyComponent } from './pages/boostly/boostly.component';
import { ChargeautomationComponent } from './pages/chargeautomation/chargeautomation.component';
import { CleansterComponent } from './pages/cleanster/cleanster.component';
import { ClearingComponent } from './pages/clearing/clearing.component';
import { ConnectedAppsComponent } from './pages/connected-apps/connected-apps.component';
import { EmailRoutingComponent } from './pages/email-routing/email-routing.component';
import { MailchimpComponent } from './pages/mailchimp/mailchimp.component';
import { OwnercenterComponent } from './pages/ownercenter/ownercenter.component';
import { SmartlockSuccessComponent } from './pages/smartlock-success/smartlock-success.component';
import { SmartlockComponent } from './pages/smartlock/smartlock.component';
import { StayfiComponent } from './pages/stayfi/stayfi.component';
import { TidyComponent } from './pages/tidy/tidy.component';
import { UpvoteComponent } from './pages/upvote/upvote.component';
import { WebhooksNextComponent } from './pages/webhooks/webhooks-next.component';

const routes: Routes = [
  {
    path: '',
    component: AppsOverviewComponent,
    data: {
      title: 'Apps',
    },
  },
  {
    path: 'mailchimp',
    component: MailchimpComponent,
    data: {
      title: 'Mailchimp',
    },
  },
  {
    path: 'webhooks',
    component: WebhooksNextComponent,
    data: {
      title: 'Webhooks',
    },
  },
  {
    path: 'connected-apps',
    component: ConnectedAppsComponent,
    data: {
      title: 'Connected Apps',
      redirectTo: '/apps',
    },
  },
  {
    path: 'api-keys',
    redirectTo: 'api-access',
  },
  {
    path: 'api-access',
    component: ApiKeysComponent,
    data: {
      title: 'API access',
    },
  },
  {
    path: 'email-routing',
    component: EmailRoutingComponent,
    data: {
      title: 'Email routing',
    },
  },
  {
    path: 'autohost',
    component: AutohostComponent,
    data: {
      title: 'Autohost',
    },
  },
  {
    path: 'integrations',
    component: UpvoteComponent,
    data: {
      title: 'Missing an integration?',
    },
  },
  {
    path: 'remotelock',
    component: SmartlockComponent,
    data: {
      title: 'RemoteLock',
      identifier: 'apps-remotelock',
    },
  },
  {
    path: 'remotelock/success',
    component: SmartlockSuccessComponent,
    data: {
      title: 'RemoteLock - Success',
    },
  },
  {
    path: 'remotelock/:status',
    component: SmartlockComponent,
    data: {
      title: 'RemoteLock',
    },
  },
  {
    path: 'cleanster',
    component: CleansterComponent,
    data: {
      title: 'Cleanster',
    },
  },
  {
    path: 'thehostco',
    component: TheHostCoComponent,
    data: {
      title: 'The Host Co.',
    },
  },
  {
    path: 'techtape',
    component: TechtapeComponent,
    data: {
      title: 'TechTape',
    },
  },
  {
    path: 'hudson-creative',
    component: HudsonCreativeStudioComponent,
    data: {
      title: 'Hudson Creative Studio',
    },
  },
  {
    path: 'pricelabs',
    component: PricelabsComponent,
    data: {
      title: 'Pricelabs',
    },
  },
  {
    path: 'craftedstays',
    component: CraftedstaysComponent,
    data: {
      title: 'CraftedStays',
    },
  },
  {
    path: 'hostkit',
    component: HostkitComponent,
    data: {
      title: 'Hostkit',
    },
  },
  {
    path: 'ownercenter',
    component: OwnercenterComponent,
    data: {
      title: 'Ownercenter',
    },
  },
  {
    path: 'jervis',
    component: JervisComponent,
    data: {
      title: 'Jervis Systems',
    },
  },
  {
    path: 'linkbase',
    component: LinkbaseComponent,
    data: {
      title: 'Linkbase',
    },
  },
  {
    path: 'breezeway',
    component: BreezewayComponent,
    data: {
      title: 'Breezeway',
    },
  },
  {
    path: 'strly',
    component: StrlyComponent,
    data: {
      title: 'Strly',
    },
  },
  {
    path: 'suiteop',
    component: SuiteopComponent,
    data: {
      title: 'SuiteOp',
    },
  },
  {
    path: 'touchstay',
    component: TouchstayComponent,
    data: {
      title: 'Touch Stay',
    },
  },
  {
    path: 'rankbreeze',
    component: RankbreezeComponent,
    data: {
      title: 'Rankbreeze',
    },
  },
  {
    path: 'houfy',
    component: HoufyComponent,
    data: {
      title: 'Houfy',
    },
  },
  {
    path: 'resortcleaning',
    component: ResortcleaningComponent,
    data: {
      title: 'ResortCleaning',
    },
  },
  {
    path: 'webready',
    component: WebreadyComponent,
    data: {
      title: 'Webready',
    },
  },
  {
    path: 'chekin',
    component: ChekinComponent,
    data: {
      title: 'Chekin',
    },
  },
  {
    path: 'minut',
    component: MinutComponent,
    data: {
      title: 'Minut',
    },
  },
  {
    path: 'vrplatform',
    component: VRPlatformComponent,
    data: {
      title: 'VRPlatform',
    },
  },
  {
    path: 'tidy',
    component: TidyComponent,
    data: {
      title: 'TIDY',
    },
  },
  {
    path: 'stayfi',
    component: StayfiComponent,
    data: {
      title: 'StayFi',
    },
  },
  {
    path: 'clearing',
    component: ClearingComponent,
    data: {
      title: 'Clearing',
    },
  },
  {
    path: 'alertify',
    component: AlertifyComponent,
    data: {
      title: 'Alertify',
    },
  },
  {
    path: 'chargeautomation',
    component: ChargeautomationComponent,
    data: {
      title: 'ChargeAutomation',
    },
  },
  {
    path: 'boostly',
    component: BoostlyComponent,
    data: {
      title: 'Boostly',
    },
  },
  {
    path: 'beyond',
    component: BeyondComponent,
    data: {
      title: 'Beyond',
    },
  },
  {
    path: 'quickbooks',
    component: QuickbooksComponent,
    data: {
      title: 'Intuit Quickbooks',
    },
  },
  {
    path: 'hostbuddy-ai',
    component: HostbuddyAiComponent,
    data: {
      title: 'HostBuddy AI',
    },
  },
  {
    path: 'better-str',
    component: BetterStrComponent,
    data: {
      title: 'Better STR',
    },
  },
  {
    path: 'safely',
    component: SafelyComponent,
    data: {
      title: 'Safely',
    },
  },
  {
    path: 'crewdogs',
    component: CrewdogsComponent,
    data: {
      title: 'Crewdogs',
    },
  },
  {
    path: 'rue-ba-rue',
    component: RueBaRueComponent,
    data: {
      title: 'RueBaRue',
    },
  },
  {
    path: 'welcomescreen',
    component: WelcomescreenComponent,
    data: {
      title: 'WelcomeScreen',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppsRoutingModule {}
